import { create } from "zustand";
import { getNotifications, markNotifRead, markAllNotifRead } from "@/lib/mgmt";

export interface AppNotification {
  id: string;
  title: string;
  body: string;
  kind: "info" | "success" | "warning" | "ai";
  link?: string;
  read: boolean;
  at: string;
}

interface NotificationState {
  items: AppNotification[];
  unread: number;
  loading: boolean;
  fetch: () => Promise<void>;
  markRead: (id: string) => Promise<void>;
  markAll: () => Promise<void>;
}

export const useNotificationStore = create<NotificationState>((set, get) => ({
  items: [],
  unread: 0,
  loading: false,
  fetch: async () => {
    set({ loading: true });
    try {
      const d = await getNotifications();
      set({ items: d.items || [], unread: d.unread || 0 });
    } catch {
      /* silent */
    } finally {
      set({ loading: false });
    }
  },
  markRead: async (id) => {
    await markNotifRead(id);
    await get().fetch();
  },
  markAll: async () => {
    await markAllNotifRead();
    await get().fetch();
  },
}));
